import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=5d9cef24"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports